export const ROUTES = {
  login: '/login',
  agents: {
    overview: '/agents',
    details: (activityId: number): string => `/agents/${activityId}`,
  },
  activityLog: {
    overview: '/activities/log',
    details: (activityId: number): string => `/activities/log/${activityId}`,
  },
  activities: {
    overview: '/activities',
    details: (activityId: number): string => `/activities/${activityId}`,
  },
  contacts: {
    overview: '/contacts',
    details: (contactId: number): string => `/contacts/${contactId}`,
  },
  clients: {
    overview: '/clients',
    relationshipManagement: '/clients/relationship-management',
    details: (clientId: number): string => `/clients/${clientId}`,
  },
  opportunities: {
    index: '/opportunities',
    dashboard: '/opportunities/dashboard',
    overview: '/opportunities/overview',
    details: (opportunityId: number): string =>
      `/opportunities/overview/${opportunityId}`,
  },
};
